import React from "react";
import { Switch, Field, Description, Label } from "@headlessui/react";
import classNames from "../../utils/class-names";

export interface ToggleProps {
    disabled?: boolean;
    toggled: boolean;
    onToggledChange: (isToggled: boolean) => void;
    name?: string;
    label?: string;
    description?: string;
    className?: string;
    classNameLabel?: string;
}

const Toggle: React.FC<ToggleProps> = ({
    disabled = false,
    toggled,
    onToggledChange,
    name,
    label,
    description,
    className = "flex items-center justify-between gap-3",
    classNameLabel = "text-sm font-medium text-gray-900"
}) => (
    <Field as="div" className={className}>
        <Switch
            disabled={disabled}
            checked={toggled}
            onChange={onToggledChange}
            name={name}
            className={classNames(
                "group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full",
                "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-2"
            )}
        >
            {/* Track */}
            <span
                aria-hidden="true"
                className={classNames(
                    "absolute h-4 w-9 rounded-full transition-colors duration-200 ease-in-out",
                    toggled
                        ? "bg-indigo-600"
                        : "bg-gray-200 dark:bg-gray-700"
                )}
            />

            {/* Thumb */}
            <span
                aria-hidden="true"
                className={classNames(
                    "absolute left-0 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ease-in-out",
                    toggled ? "translate-x-5" : "translate-x-0"
                )}
            />
        </Switch>

        <div className="flex flex-col">
            <Label
                as="span"
                className={classNameLabel}
                passive
            >
                {label}
            </Label>

            {description && (
                <Description className="text-xs text-gray-500">
                    {description}
                </Description>
            )}
        </div>
    </Field>
);

export default Toggle;
